import {
  MaterialUICore,
  axiomTokens,
  TextField as DSTextField,
} from '@iclinic/design-system';

const { styled } = MaterialUICore;
const { spacing, color } = axiomTokens;

export const Root = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

export const FieldsWrapper = styled('div')(({ theme }) => ({
  gap: spacing[4],
  gridTemplateColumns: '3fr 1fr 1fr 1fr',
  gridTemplateAreas: `
      "radio radio radio radio"
      "document name name name"
      "cep birthdate birthdate birthdate"
      "address address address number"
      "complement neighborhood neighborhood neighborhood"
      "city city state state"
    `,
  display: 'grid',

  [theme.breakpoints.down('xs')]: {
    gridTemplateColumns: '1.3fr 1fr',
    gridTemplateAreas: `
      "radio radio"
      "document document"
      "name name"
      "cep cep"
      "birthdate birthdate"
      "address address"
      "complement number"
      "neighborhood neighborhood"
      "city state"
    `,
  },
}));

export const TextComplement = styled(DSTextField)(({ theme }) => ({
  gridArea: 'complement',

  [theme.breakpoints.down('xs')]: {
    marginRight: '-6px',
  },
}));

export const RadioWrapper = styled('div')({
  gridArea: 'radio',
  display: 'flex',
  alignItems: 'center',

  '& > .MuiRadio-root': {
    padding: 0,
    color: color.interactive.accent.default,
  },

  '& > .Mui-checked': {
    color: color.interactive.accent.default,
  },
});
